<div class="d-flex flex-column flex-root all-height">
  <div
    class="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
    id="kt_login"
  >
    <!--begin::Content-->
    <div class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden p-lg-10">
      <!--begin::Content header-->
      <!--      <div class=" mt-5 mb-15 mb-lg-0  d-flex justify-content-center text-align-center">-->
      <!--        <a  class="flex-column-auto mt-5">-->
      <!--          <img src="./assets/media/logos/aplosLogo.png" class="max-h-70px"/>-->
      <!--        </a>-->
      <!--      </div>-->
      <!--end::Content header-->
      <!-- <div [@routeAnimations]="prepareRoute(routerOutlet)" > -->

      <router-outlet></router-outlet>
      <!-- </div> -->
      <!--begin::Content footer for mobile-->
      <div
        class="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5"
      >
        <div class="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
          &copy; 2020 Medido Health LLC
        </div>
        <div class="d-flex order-1 order-sm-2 my-2">
          <a href="#" class="text-dark-75 text-hover-primary">Privacy</a>
          <a href="#" class="text-dark-75 text-hover-primary ml-4">Legal</a>
          <a href="#" class="text-dark-75 text-hover-primary ml-4">Contact</a>
        </div>
      </div>
      <!--end::Content footer for mobile-->
    </div>
    <!--end::Content-->
    <!--begin::Aside-->
    <div
      class="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 hide-small"
      style="background-image: linear-gradient(#00aaff, #023e61)"
    >
      <!--begin: Aside Container-->
      <div class="d-flex flex-row-fluid flex-column justify-content-between">
        <!--begin: Aside header-->

        <!--end: Aside header-->

        <!--begin: Aside content-->
        <div class="flex-column-fluid d-flex flex-column justify-content-center">
          <h3 class="font-size-h1 mb-5 text-white text-align-center">Knostos Application</h3>
          <h5 class="font-size-h5 mb-5 text-white text-align-center">
            Pharmacy Operating & Executing System (POES)
          </h5>
          <p class="font-weight-lighter text-white opacity-80 text-align-center padding-in-large">
            A single platform that facilitates the servicing of the modern pharmacy client and
            considers the complexity of the system
          </p>
        </div>
        <!--end: Aside content-->

        <!--begin: Aside footer for desktop-->
        <div class="d-none flex-column-auto d-lg-flex justify-content-center mt-10 max-high-pic">
          <div class="photoLogin">
            <img src="./assets/media/logos/doctorlogin.svg" class="doctorsSvg" />
          </div>
        </div>
        <!--end: Aside footer for desktop-->
      </div>
    </div>
    <!--begin::Aside-->
  </div>
</div>
